import { throw_expression } from "../../utils/flow-control";
import { AssetManager } from "../AssetManager";
import { GameState } from "../consts/GameState";
import { Game } from "../logic/Game";
import { EffectsView } from "./EffectsView";
import { EnemiesView } from "./EnemiesView";
import { GameMapView } from "./GameMapView";
import { GameUiView } from "./GameUiView";

export class GameView {
    public context: CanvasRenderingContext2D;

    public readonly map_width = 160;
    public readonly map_height = 160;
    public readonly field_width = this.map_width / this.game.map.width;
    public readonly field_height = this.map_height / this.game.map.height;

    public game_map_view: GameMapView;
    public game_ui_view: GameUiView;
    public enemies_view: EnemiesView;
    public effects_view: EffectsView;

    constructor(
        public canvas: HTMLCanvasElement,
        public assets: AssetManager,
        public game: Game,
    ) {
        this.context = canvas.getContext("2d") || throw_expression("Could not instantiate context");
        this.context.imageSmoothingEnabled = false;
        this.game_map_view = new GameMapView(game, assets, this, this.context);
        this.enemies_view = new EnemiesView(game, assets, this, this.context);
        this.effects_view = new EffectsView(game, assets, this, this.context);
        this.game_ui_view = new GameUiView(game, assets, this, this.context);
    }

    public update() {
        this.clear_context();
        switch (this.game.state) {
            case GameState.LOST:
                this.update_on_game_lost();
                break;
            case GameState.LOADING:
            case GameState.PLAYING:
                this.update_playing();
                break;
        }
    }

    private update_playing() {
        this.game_map_view.update();
        this.enemies_view.update();
        this.effects_view.update();
        this.game_ui_view.update();
    }

    private update_on_game_lost() {
        this.context.fillStyle = "red";
        this.context.textAlign = "center";
        this.context.textBaseline = "middle";
        this.context.font = "20px monospace";
        this.context.fillText("Player Lost", this.canvas.width / 2, this.canvas.height / 2);
        this.game_ui_view.update();
    }

    private clear_context() {
        this.context.imageSmoothingEnabled = false;
        this.context.fillStyle = "#888888";
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

}